import { Outlet } from "react-router-dom";
import { AppLayout as SharedAppLayout } from "@scryerlabs/ui";
import { AppHeader } from "./AppHeader";
import { AppFooter } from "./AppFooter";
import { AppSidebar } from "./AppSidebar";
import { ScrollToTop } from "./ScrollToTop";

/**
 * The sidebar/header open state now lives in the package. Both apps held the same pair of
 * useState hooks and threaded them down by hand, which is exactly the repeated decision
 * worth removing - and the reason the shell takes render props rather than plain slots.
 */
export function AppLayout() {
  return (
    <SharedAppLayout
      sidebar={({ sidebarVisible, setSidebarVisible, unfoldable, setUnfoldable }) => (
        <AppSidebar
          visible={sidebarVisible}
          onVisibleChange={setSidebarVisible}
          unfoldable={unfoldable}
          onUnfoldableChange={setUnfoldable}
        />
      )}
      header={({ toggleSidebar }) => <AppHeader onToggleSidebar={toggleSidebar} />}
      footer={<AppFooter />}
    >
      {/* Sits inside the shell so it survives child route changes — the thing it
          reacts to. Renders nothing. */}
      <ScrollToTop />
      <Outlet />
    </SharedAppLayout>
  );
}
